import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_TOKEN } from 'constants/constants';

export interface IMillListItem {
  id: number;
  name: string;
}

export const millsApi = createApi({
  reducerPath: 'millsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    prepareHeaders: (headers) => {
      const authToken = localStorage.getItem(API_TOKEN);
      if (authToken) {
        headers.set('Authorization', `Bearer ${authToken}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getMills: builder.query<IMillListItem[], void>({
      query: () => ({
        url: '/v2/analytics/mills/all',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetMillsQuery } = millsApi;
